import React from 'react';
import styled from 'styled-components';

import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { TextArea } from '../atom/Textarea';

export const TextareaWithCounter = ({
  maxLength = 20,
  onChange = undefined,
  ...props
}) => {
  const count = props.value.length;

  return (
    <Flex column width="100%" alignItems="end" style={{ position: 'relative' }}>
      <TextArea {...props} onChange={onChange} maxLength={maxLength} />
      <TextareaCounter padding="0.375rem">
        <Text size={10} color="orangePink" style={{ marginRight: '0.375rem' }}>
          {count > maxLength && `* ${maxLength}자 이내로 입력해주세요`}
        </Text>
        <Text size={10} color="pinkishGrey">
          {count}/{maxLength}
        </Text>
      </TextareaCounter>
    </Flex>
  );
};

export const TextareaCounter = styled(Flex)`
  position: absolute;
  bottom: 0;
  right: 0;
`;
